module.exports = __webpack_public_path__ + "img/no_data.9909b1bf.png";